<template>
    <div>
        <div v-if="!selectedProduct">
            <JobBoardFilters />
            <div class="border-t w-full my-24"></div>
            <div class="mb-24">
                <p class="text-heading-2 font-semibold">{{ $t('multi-posting.tabs.job-boards.title') }}</p>
            </div>
            <div v-if="fetchingProducts" class="flex justify-center items-center">
                <loading />
            </div>
            <div v-else class="grid grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-24" >
                <div v-for="product in products" :key="product.id">
                    <JobBoardListItem
                        :product="product"
                        @add-to-campaign="$emit('add-to-campaign', product)"
                        @view-details="setViewDetails"
                        @view-vacancies="setViewVacancies"
                    />
                </div>
                <loading v-if="fetchingNextProducts"  class="my-24 col-span-full"/>
            </div>
        </div>

        <jobBoardVacancies
            v-if="selectedProduct && viewVacancies"
            :product="selectedProduct"
            @close="close"
        />

        <popup-modal
            v-if="selectedProduct && viewDetails"
            custom-classes="w-768"
            :text-center="false"
            @close="close"
        >
            <JobBoardDetails :product="selectedProduct" @add-to-campaign="$emit('add-to-campaign', $event)" />
        </popup-modal>
    </div>
</template>

<script>
import ContractListItem from "./ContractListItem.vue";
import MultiPostingDiscoverListItem from "./MultiPostingDiscoverListItem.vue";
import JobBoardListItem from "./JobBoardListItem.vue";
import Loading from "../ui/Loading.vue";
import PopupModal from "../ui/PopupModal.vue";
import JobBoardDetails from "./JobBoardDetails.vue";
import JobBoardVacancies from "./JobBoardVacancies.vue";
import {mapActions, mapState} from "pinia";
import {useMainStore} from '../../state/store';
import {useMultiPostingStore} from '../../state/modules/multiPosting';
import JobBoardFilters from "./JobBoardFilters.vue";

export default {
    name: 'JobBoardList',
    components: {
        JobBoardFilters,
        JobBoardVacancies,
        JobBoardDetails, PopupModal, Loading, JobBoardListItem, MultiPostingDiscoverListItem, ContractListItem},
    props: {
        hasMultiPostingSubscription: {
            type: Boolean,
            default: false,
        },
    },
    data: function () {
        return {
            selectedProduct: null,
            productJobs: null,
            viewDetails: false,
            viewVacancies: false,
        }
    },
    computed: {
        ...mapState(useMultiPostingStore, ['products', 'pagination', 'fetchingProducts', 'fetchingNextProducts']),
        ...mapState(useMainStore, ['currentCompany']),
    },
    methods: {
        ...mapActions(useMultiPostingStore, ['resetFilters', 'resetPagination', 'fetchProducts', 'fetchJobBoardData']),
        setViewDetails(product) {
            this.selectedProduct = product;
            this.viewDetails = true;
        },
        setViewVacancies(product) {
            this.selectedProduct = product;
            this.viewVacancies = true;
        },
        handleScroll(event) {
            const bottomDistance = event.target.scrollHeight - event.target.scrollTop - event.target.clientHeight;
            if (bottomDistance < 200 && this.pagination._pager.next && (!this.fetchingProducts && !this.fetchingNextProducts)) {
                this.fetchProducts({next: true});
            }
        },
        close() {
            this.selectedProduct = null;
            this.viewDetails = false;
            this.viewVacancies = false;
        }
    },
    beforeMount() {
        this.resetFilters();
        this.fetchProducts({pagination: this.pagination});
        this.fetchJobBoardData();
    },
    mounted() {
        document
            .getElementById('content-container')
            .addEventListener('scroll', this.handleScroll);
    },
    beforeUnmount() {
        this.resetPagination();
        document
            .getElementById('content-container')
            .removeEventListener('scroll', this.handleScroll);
    }
}
</script>
